module.exports = __webpack_public_path__ + "img/login_paw.60dff0e7.png";